
<div class="provider-dashboard">
  <h1>Tableau de bord Provider</h1>
  <mat-accordion multi>
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h5>Mon Parc </h5>
          <button class="simple-button" mat-button routerLink="/provider/park"><mat-icon>open_in_new</mat-icon>Gérer</button>

        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (dealerData != undefined) {
        <div>
          <h6><a [routerLink]="['/provider/park']">Voir mes voitures</a></h6>
          <h6><a [routerLink]="['/owner/post-new-car']">Poster une voiture</a></h6>
        </div>
      }

    </mat-expansion-panel>

    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h5>Ventes</h5>
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (dealerData != undefined) {
        <div>
          <h6><a [routerLink]="['/provider/buy']">Ventes en cours </a></h6>
          <h6><a [routerLink]="['/provider/buy']">Ventes conclues</a></h6>
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h5>Locations</h5>
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (dealerData != undefined) {
        <div>
          <h6><a [routerLink]="['/provider/rent']">Réservations</a></h6>
          <h6><a [routerLink]="['/provider/rent']">Locations en cours</a></h6>
          <h6><a [routerLink]="['/provider/rent']">Locations conclues</a></h6>
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h5>Communications</h5>
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (dealerData != undefined) {
        <div>
          <h6><a [routerLink]="['/provider/appointments']">Mes rendez-vous </a></h6>
          <h6><a [routerLink]="['/provider/conversations']">Mes conversations</a></h6>
          <h6><a [routerLink]="['/provider/notifications']">Notifications </a></h6>
        </div>
      }
    </mat-expansion-panel>

    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h5>Mon Profil</h5>
          <button class="simple-button" mat-button routerLink="/provider/public">
            <mat-icon>open_in_new</mat-icon>Profil public
          </button>

        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (dealerData != undefined) {
        <div>
          <h6><a [routerLink]="['/provider/my-owners']">Mes proprio </a></h6>
          <h6><a [routerLink]="['/provider/contracts']">Mes contrats</a></h6>
          <h6><a [routerLink]="['/provider/account']">Mon compte</a></h6>
          <h6><a [routerLink]="['/provider/public']" [queryParams]="{id: dealerData.username}">Voir mon profil public </a></h6>
        </div>
      }
    </mat-expansion-panel>

  </mat-accordion>

</div>







